import React from 'react'
import ReactDOM from 'react-dom'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import history from '../../history'
import * as configurationActions from '../../actions/configurationActions'
import * as updateConfigurationActions from '../../actions/updateConfigurationActions'
import * as adminConfigActions from '../../actions/adminConfigActions'
import * as familySpaceActions from '../../actions/familySpaceActions'
import * as uiActions from '../../actions/uiActions'
import { BaseHeightOptionPanel } from '../configurator/components/BaseHeightOptionPanel'
import { Fheader } from './Fheader'
import { Alert, Button } from 'reactstrap'
import { SideAction } from './components/SideActions'
import { Viewer3D } from '../../components/Viewer3D'
import { SocialNetwork } from '../../components/SocialNetwork'
import { Modal } from '../../components/Modal'
import { isSmartphone } from '../../services/domFunctions'
import { put, get } from '../../services/api.service'
import { getDesignTypeConfiguration } from '../../services/utils.service'
import * as FileSaver from 'file-saver'
import { Fquote } from './Fquote'
import LoadConfig from '../../components/LoadConfig'
import FTopBar from './FTopBar'
import { FpriceList } from './components/FpriceList'
import { FdetailInfosB } from './components/FdetailInfosB'
import cube from '../../images/Icon_360.svg'
import gpg from '../../images/svg_icon.svg'
import { checkStatusFlowers } from '../../services/flower.service'
import showFlowerImg from '../../images/Icons_Flowers.svg'
import hideFlowerImg from '../../images/Icons_Flowers_1.svg'
import { isFamilySpaceOn } from '../../services/utils.service'
import { SFamilyLoginForm } from '../family_space/SFamilyLoginForm'
import FLoader from '../../../src/components/FLoader.js'
import MediaQuery from "react-responsive/src";
import { NotifUpdate } from "../configurator/components/NotifUpdate";
import { FiltersBurial } from '../../constants.js';
import { gtmFamily } from '../../services/gtmFamily';
import {LazyImage} from '../../../src/components/LazyImage';

class FcustomizeComponent extends React.Component {
  state = {
    showQuote: false,
    showQuoteAsk: false,
    shareModalVisible: false,
    showAlert: 0,
    showPdfModal: false,
    pdfUrl: null,
    showConfirmModal: false,
    loadPdf: false,
    directDownload: false,
    directDownloaded: false,
    show3DView: false,
    showDetails: false,
    status: 'flowersDisabled',
    confirmBackToCatalog: false
  }

  componentDidMount = () => {
    const status = checkStatusFlowers()
    this.setState({ status })

    const directDownload = window.location.search.includes('download')
    if (directDownload) this.setState({ directDownload: true })

    if (!this.state.showDetails) {
      document.addEventListener('mousedown', this.clicOutsideDetails)
    }
    window.addEventListener("popstate", this.detectBack);
    // 

    const { configId } = this.props.match.params
    if (!this.props.configurator) {
      this.props.configurationActions.getConfiguration(configId)
    }
  }

  detectBack = () => {
    if (this.state.showPdfModal == true) this.setState({ showPdfModal: false, pdfUrl: null });
  }
  clicOutsideDetails = (event) => {
    if (this.state.showDetails === false) {
      return
    }
    const domNode = ReactDOM.findDOMNode(this)
    if (!domNode || !domNode.contains(event.target)) {
      if (event.target.contains(document.getElementById('smallDetailsPop'))) {
        this.setState({ showDetails: false })
      }
    }
  }

  adjustNameMonument = (catalogs, monument) => {
    if (!monument || !monument.params) { return monument; }
    const params = JSON.parse(monument.params);
    if (!Array.isArray(params.catalogs)) { return monument; }
    for (const cata of params.catalogs) {
      if (cata.name !== "" && catalogs.includes(cata.catalogId.toString())) {
        monument.name = cata.name;
        monument.alternativeMonumentName = cata.name;
        break;
      }
    }
    return monument;
  }

  componentDidUpdate = async (prevProps, prevState) => {
    if (this.props.configurator && prevProps.configurator 
      && !this.props.configurator.configuration.monument.alternativeMonumentName 
      && prevProps.configurator.configuration.monument.alternativeMonumentName) {
        const catalogs = this.props.user.identity.organization.catalogs?.split(",") || null;
        const monument = {...this.props.configurator.configuration.monument}
        const updatedMonument = this.adjustNameMonument(catalogs, monument)
        this.props.configurationActions.adjustNameMonument(updatedMonument);
      };

    if (
      this.state.directDownload &&
      !this.state.directDownloaded &&
      !prevState.directDownload &&
      !!window.location.search.includes('download')
    ) {
      const { configId } = this.props.match.params
      this.getPdfData(configId, true)
    }
    const status = checkStatusFlowers()
    if (status !== this.state.status) {
      this.setState({ status })
    }

    const { configId } = this.props.match.params
    if (!this.props.configurator && !prevProps.configurator) {
      await this.props.configurationActions.getConfiguration(configId)
    }

    if((this.props.configurator && !prevProps.configurator) 
      || (prevProps.configurator && prevProps.configurator.configuration && !prevProps.configurator.configuration.monument.weight && this.props.configurator.configuration.monument.weight)
      ) 
    {
      const catalogs = this.props.user.identity.organization.catalogs?.split(",") || null;
      const monument = {...this.props.configurator.configuration.monument}
      const updatedMonument = this.adjustNameMonument(catalogs, monument)
      this.props.configurationActions.adjustNameMonument(updatedMonument);
    }
    
    // GTM
    const showBtnFlowers = status !== 'flowersHiddenForOrg' && status !== 'flowersNotAvailable'
    if (!prevProps.configurator && this.props.configurator) {
      gtmFamily().loadConfiguration(this.props.configurator, FiltersBurial, showBtnFlowers)
    }
    // end GTM
  }


  displayAlertSentMail = (result) => {
    const typeAlert = result && result.messageId ? 1 : 2
    this.setState({ showAlert: typeAlert }, () => {
      window.setTimeout(() => {
        this.setState({ showAlert: 0 })
      }, 2000)
    })
  }

  updateConfigSocialStats = async (item) => {
    const { configurator } = this.props
    let stats = configurator.configuration.stats
    if (stats.share.includes(item)) return
    stats.share.push(item)
    await put(
      `/api/configuration/simpleupdate/${configurator.configuration.reference}`,
      { 'stats.share': stats.share }
    )
  }

  gtmEndpoint = (type) => {
    let auxObj = {
      category: "configurateur",
      type: "picto",
      from: "configuration personnalisation"
    }
    // GTM
    switch (type) {
      case "fcatalog":
        auxObj = {
          ...auxObj,
          name: "catalogue",
          subcategory: "liste produits"
        }
        break;
      case "fgranit":
        auxObj = {
          ...auxObj,
          name: "modifier granit",
          subcategory: "liste granits"
        }
        break;
      case "faccessoire":
        auxObj = {
          ...auxObj,
          name: "ajouter accessoire",
          subcategory: "liste accessoires"
        }
        break;
      case "fmotif":
        auxObj = {
          ...auxObj,
          name: "ajouter motif",
          subcategory: "liste motifs"
        }
        break;
      case "fgravure":
        auxObj = {
          ...auxObj,
          name: "ajouter gravure",
          subcategory: "gravure"
        }
        break;
    }
    
    gtmFamily().ctaOfConfiguration(auxObj, { template: "configurateur", subtemplate: "produit" }, {}, "partner", "product", "user", "page")
    // end GTM
  } 

  goEndpoint = (endpoint, force = false) => {
    const { configId, clientId } = this.props.match.params

    if (endpoint === 'fcatalog') {
      if (force) {
        history.push(`/famille/${clientId}`)
        this.props.uiActions.initialChoiceMade(false)
        // GTM
        this.gtmEndpoint(endpoint)
        // end GTM
      } else {
        this.setState({ showConfirmModal: true })
      }
    } else {
      // GTM
      this.gtmEndpoint(endpoint)
      // end GTM
      history.push(`/famille/${clientId}/${configId}/${endpoint}`)
    }
  }

  getPdfData = async (ref, open = null) => {
    const {alternativeMonumentName = ""} = this.props.configurator.configuration.monument
    if (open) this.setState({ loadPdf: true })
    // Get PDF data
    const pdfData = this.state.pdfData
      ? this.state.pdfData
      : await get(
          `/api/get/pdf/config?type=family&configuration=${ref}&alternativeMonumentName=${alternativeMonumentName}`,
          false,
          false,
          'blob'
        )

    if (pdfData) {
      this.setState({ pdfData, directDownload: false })
      if (open) {
        this.getPdfUrl(pdfData)
      }
      return pdfData
    }
  }

  getPdfUrl = (pdfData = null) => {
    const { reference } = this.props.configurator.configuration
    const data = pdfData || this.state.pdfData
    const file = new Blob([data], { type: 'application/pdf' })

    if (isSmartphone()) {
      FileSaver.saveAs(file, `monument_${reference}.pdf`)
    } else {
      const fileUrl = URL.createObjectURL(file)
      this.setState({ pdfUrl: fileUrl }, () => {
        this.setState({
          showPdfModal: true,
          loadPdf: false,
          directDownloaded: true
        })
      })
    }

    // Update STATE
    if (!this.props.configurator.configuration.stats.pdfDownloaded) {
      let stats = this.props.configurator.configuration.stats
      stats.pdfDownloaded = true
      put(`/api/configuration/simpleupdate/${reference}`, { stats })
      // Appel uniquement pour les stats pas la peine de mettre à jour la config ni d'attendre la réponse
    }
  }

  showPdf = async () => {
    // GTM
    gtmFamily().ctaOfConfiguration({
      name: "télécharger",
      category: "télécharger",
      subcategory: "",
      type: "cta",
      from: "configuration header"
    }, { template: "configurateur", subtemplate: "produit" }, {}, "partner", "product", "user")
    // end GTM
    const { reference } = this.props.configurator.configuration
    this.setState({ loadPdf: true })
    window.history.pushState({id:1}, null,"?downloadPDF")
    // Get PDF data
    const pdfData = await this.getPdfData(reference)

    // Get PDF url
    if (pdfData) {
      this.getPdfUrl(pdfData)
    }
  }

  goCustomize = () => {
    const { client, reference } = this.props.configurator.configuration
    history.push(`/famille/${client}/${reference}/customize`)
  }
  backToCatalogModal = (bShow=false) => {
    this.setState({confirmBackToCatalog:bShow});
  }
  goToCatalog= () =>{
    this.goEndpoint('fcatalog', true);
  }

  showQuoteAskForm = () => {
    // GTM
    gtmFamily().ctaOfConfiguration({
      name: "demander un devis",
      category: "devis",
      subcategory: "",
      type: "picto",
      from: "configuration header"
    }, { template: "configurateur", subtemplate: "produit" }, {}, "partner", "product", "user", "page")
    // end GTM
    this.setState({ showDetails: true, showQuoteAsk: true })
  }

  familyspaceAccess = (from = null) => {
    if (from === "shareBtn") { 
      // GTM
      gtmFamily().ctaOfConfiguration({
        name: "sauvegarder",
        category: "espace famille",
        subcategory: "",
        type: "picto",
        from: "partager"
      }, { template: "configurateur", subtemplate: "produit" }, {}, "partner", "product", "user", "page")
      // end GTM
    }
    else {
      // GTM
      gtmFamily().ctaOfConfiguration({
        name: "sauvegarder",
        category: "espace famille",
        subcategory: "",
        type: "cta",
        from: "configuration header"
      }, { template: "configurateur", subtemplate: "produit" }, {}, "partner", "product", "user", "page")
      // end GTM
    }
    if (this.props.familySpace && this.props.familySpace.ca_client) {
      history.push(`/famille/${this.props.familySpace.ca_client}/familyspace`);
    } else {
      this.props.familySpaceAction.openLoginModal()
    }
  };

  changeFlowerDisplay = () => {
    const { configurator } = this.props 
    this.props.updateConfigurationAction.changeFlowerDisplay(
      !configurator.configuration.hideFlowers
    )
    // GTM
    gtmFamily().ctaOfConfiguration({
      name: "masquer les fleurs",
      category: "configurateur",
      subcategory: "produit",
      type: "picto",
      from: "configuration personnalisation"
    }, { template: "configurateur", subtemplate: "produit" })
    // end GTM 
  }

  show3DViewFunction = (show3DView) => {
    this.setState({ show3DView: !show3DView })
    // GTM
    gtmFamily().ctaOfConfiguration({
      name: "visualiser en 3d",
      category: "configurateur",
      subcategory: "3d",
      type: "picto",
      from: "configuration personnalisation"
    }, { template: "configurateur", subtemplate: "produit" })
    // end GTM 
  }

  render() {
    const {
      isoview,
      configurator,
      user,
      familyService,
      familySpace,
      familySpaceUser
    } = this.props
    const family = configurator && configurator.configuration && configurator.configuration.configType=='family'
    const {
      show3DView,
      shareModalVisible,
      showAlert,
      pdfUrl,
      loadPdf,
      showPdfModal,
      showConfirmModal,
      showQuote,
      showDetails,
      confirmBackToCatalog
    } = this.state
    const { status } = this.state
    const showFlowers =
      status !== 'flowersHiddenForOrg' && status !== 'flowersNotAvailable'
    const countAccessories =
      configurator &&
      configurator.configuration &&
      configurator.configuration.accessories
        ? configurator.configuration.accessories.length
        : 0
    const designType = getDesignTypeConfiguration(
      configurator && configurator.configuration
    )
    const {mainColor, fontColor} = this.props.config
    
    if (
      configurator &&
      getDesignTypeConfiguration(configurator.configuration) === 'A'
    ) {
      const { client, reference } = configurator.configuration
      history.push(`/famille/${client}/${reference}/ffinalisation`)
    }

    if (!configurator) {
      return <LoadConfig big loading={this.props.loading} />
    }
    const openHelp = isSmartphone() ? false : true
    const url_location = window.location.href; 
    if ( isSmartphone() && url_location.includes("?downloadPDF")){
      window.history.back();
    }

    return (
      <div className='fcustomize'>
        <NotifUpdate />
        {designType === 'B' && (
          <FTopBar
            goCustomize={() => this.goCustomize()}
            current={configurator}
            user={user}
            pricesPanel={() =>
              this.setState({ showDetails: !this.state.showDetails, showQuoteAsk: false })
            }
            priceDetails={this.state.showDetails}
            download={() => this.showPdf()}
            familySpace={familySpace}
            familySpaceUser={familySpaceUser}
            isFamilySpaceOn={() => isFamilySpaceOn(this.props.user)}
            openLoginModal={() => this.props.familySpaceAction.openLoginModal()}
            from='Fcustomize'
            familyspaceAccess={(from) => this.familyspaceAccess(from)}
            openQuoteAsk={() => this.showQuoteAskForm()}
          />
        )}
        {designType === 'A' && (
          <Fheader
            match={this.props.match}
            customizeModalOption={(endpoint, force = false) =>
              this.goEndpoint(endpoint, force)
            }
          />
        )}
        {showQuote && configurator && (
          <div className='fquote-header'>
            <Fquote
              config={configurator}
              user={user}
              closable
              openHelp={openHelp}
              onClose={() => this.setState({ showQuote: false })}
              fromClass={`Fquote-customize `}
            />
            <BaseHeightOptionPanel hideDisplay={true} />
            {/* super important pour mettre à jour la bonne hauteur */}
          </div>
        )}
        {/* Barre de Menu (Verticale sur Desktop et Horizentale sur mobile) */}
        {configurator && !showQuote && (
          <div className='content'>
            <SideAction
              onSelect={(target) => this.goEndpoint(target)}
              quote={() => this.setState({ showQuote: true })}
              share={() => this.setState({ shareModalVisible: true })}
              configuration={configurator.configuration}
              openLoginModal={() =>
                this.props.familySpaceAction.openLoginModal()
              }
              goToCatalog={()=> this.backToCatalogModal(true)}
              show3D={() => this.setState({ show3DView: !show3DView }) }
            />
            <BaseHeightOptionPanel hideDisplay={true} />
            {/* super important pour mettre à jour la bonne hauteur */}
            <div className='monumentImg-wrapper'>
            {/* <img className='monumentImg' src={isoview.current} alt=' monument' />  */}

              {!isoview.loading ? <LazyImage className="monumentImg" src={isoview.current} fromFamily={family} bigImage={true} />
              : <LoadConfig big loading={isoview.loading} />}
            </div>
          </div>
        )}
        {
          /* Affichage de la liste des prix et demander un devis */
          showDetails &&
            (getDesignTypeConfiguration() === 'B' || designType === 'B') && (
              <FdetailInfosB
                close={() => this.setState({ showDetails: false, showQuoteAsk: false })}
                showQuoteAsk={this.state.showQuoteAsk}
              />
            )
        }
        {/* Boutons flottants vue3d, fleurs, et sauvegarder dans l'espace famille. - DESKTOP */}
        <MediaQuery minWidth={768}>
        <div className='floatingBtnsContainer'>
          {showFlowers /* && countAccessories > 0 */ && (
            <Button
              className={`flowersBtn button-site-item-3d ${
                configurator.configuration.hideFlowers && 'hideFlower'
              }`}
              onClick={() => this.changeFlowerDisplay}
            >
              <img
                src={
                  configurator && !configurator.configuration.hideFlowers
                    ? showFlowerImg
                    : hideFlowerImg
                }
                className='flower'
                alt='afficher/cacher les fleurs'
              />
            </Button>
          )}
          <Button
            className='button-site-item-3d'
            onClick={() => this.show3DViewFunction(show3DView)}
          >
            <img src={cube} alt='Voir en 3D' />
          </Button>
          {/* {(!familySpace || !familySpaceUser) && isFamilySpaceOn(this.props.user) &&
            <Button className="button-site-item-3d saveicon" onClick={() => this.props.familySpaceAction.openLoginModal() }>
              <img src={gpg} alt="Sauvegarder dans mon espace famille." />
            </Button>} */}
        </div>
        </MediaQuery>
        {/* Btn save & ask for quote - MOBILE */}
        <MediaQuery maxWidth={768}>
          <div className='floatingBtnsContainerMobile'>
            {/*  */}
            <div className="infoBtn" onClick={() => this.familyspaceAccess()}>
              <div className='svgContainer'>
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_52310_2301)">
                    <path d="M3.98769 3.43027C4.32364 3.42669 4.64482 3.2815 4.88194 3.02602C5.11905 2.77055 5.25308 2.42526 5.25512 2.06466C5.24858 1.70608 5.11127 1.36456 4.87268 1.11345C4.6341 0.862341 4.31327 0.72168 3.97912 0.72168C3.64497 0.72168 3.32415 0.862341 3.08556 1.11345C2.84698 1.36456 2.70967 1.70608 2.70312 2.06466C2.70389 2.24487 2.73773 2.42315 2.80271 2.58931C2.86769 2.75548 2.96253 2.90628 3.08182 3.03309C3.20111 3.15991 3.34251 3.26026 3.49794 3.3284C3.65337 3.39655 3.81979 3.43117 3.98769 3.43027Z" fill="#001F2A"/>
                    <path d="M15.6147 2.04627C15.6182 2.80155 16.2049 3.425 16.8978 3.41187C17.2327 3.40548 17.552 3.25929 17.7881 3.00433C18.0242 2.74937 18.1584 2.4057 18.1623 2.04627C18.1621 1.86673 18.129 1.68899 18.0648 1.52319C18.0006 1.3574 17.9066 1.2068 17.7882 1.07999C17.6698 0.95318 17.5293 0.852648 17.3746 0.784132C17.22 0.715616 17.0544 0.680458 16.8871 0.680665C16.7198 0.680872 16.5542 0.71644 16.3997 0.785338C16.2453 0.854237 16.1049 0.955116 15.9868 1.08222C15.8686 1.20932 15.775 1.36015 15.7111 1.5261C15.6473 1.69206 15.6146 1.86988 15.6147 2.04942V2.04627Z" fill="#001F2A"/>
                    <path d="M10.1446 8.0198C10.1429 8.14372 10.1642 8.26677 10.2073 8.38175C10.2504 8.49672 10.3145 8.6013 10.3957 8.68935C10.477 8.7774 10.5738 8.84716 10.6805 8.89453C10.7872 8.9419 10.9017 8.96593 11.0172 8.96522C11.2508 8.96522 11.4748 8.86561 11.64 8.68831C11.8052 8.51101 11.898 8.27054 11.898 8.0198C11.8939 7.77295 11.8012 7.53732 11.6392 7.36205C11.4772 7.18679 11.2584 7.08543 11.0284 7.07911C10.795 7.07827 10.5709 7.17686 10.4052 7.35323C10.2395 7.5296 10.1458 7.76933 10.1446 8.0198Z" fill="#001F2A"/>
                    <path d="M19.9999 10.432C19.9906 10.4409 19.9774 10.4482 19.9725 10.4593C19.813 10.8233 19.5502 10.9908 19.2522 10.9178C18.9415 10.8427 18.7663 10.588 18.7658 10.1825C18.7628 8.66508 18.7658 7.14821 18.7609 5.63081C18.753 5.44278 18.7785 5.30359 18.641 5.30097C18.5035 5.29834 18.5245 5.50423 18.5245 5.62661C18.5222 9.20624 18.5213 12.7859 18.5216 16.3655C18.5271 16.498 18.5173 16.6306 18.4922 16.7605C18.4503 16.931 18.3558 17.0814 18.2243 17.1871C18.0927 17.2928 17.9318 17.3477 17.7675 17.343C17.5968 17.3343 17.4341 17.2632 17.3063 17.1415C17.1785 17.0197 17.0935 16.8547 17.0653 16.6738C17.0497 16.5562 17.0426 16.4375 17.0442 16.3188C17.0442 14.3821 17.0442 12.4453 17.0442 10.5086V10.2203H16.7247V10.4671C16.7247 12.4665 16.7247 14.4661 16.7247 16.4658C16.7247 16.9133 16.5177 17.2232 16.1673 17.3162C16.0706 17.3415 15.9702 17.3455 15.8721 17.3279C15.7739 17.3102 15.6801 17.2714 15.5964 17.2137C15.5127 17.1559 15.4408 17.0806 15.3851 16.9921C15.3294 16.9036 15.291 16.8039 15.2723 16.699C15.253 16.575 15.2445 16.4492 15.2468 16.3235C15.2517 12.7929 15.2577 9.26209 15.2649 5.73113C15.2649 5.66128 15.2796 5.58407 15.2566 5.52104C15.2521 5.50919 15.2463 5.49792 15.2395 5.48742C15.227 5.46705 15.21 5.4504 15.1899 5.43903C15.1698 5.42766 15.1474 5.42195 15.1247 5.42242C15.102 5.42289 15.0798 5.42954 15.0602 5.44173C15.0405 5.45393 15.0241 5.47128 15.0124 5.49215C15.0077 5.50089 15.0045 5.51051 15.0031 5.52051C14.9542 5.85141 14.9219 6.18493 14.8862 6.51845C14.7511 7.76746 14.619 9.01698 14.4819 10.266C14.4374 10.6715 14.2627 10.8574 13.8923 10.9309C13.8304 10.9456 13.7726 10.9761 13.7239 11.0197C13.4763 11.2356 13.2346 11.4572 12.9899 11.6762C12.6841 11.9483 12.5005 11.931 12.2241 11.577C12.3351 12.1384 12.4404 12.6652 12.5441 13.1926C12.6581 13.7735 12.6576 13.774 12.1007 13.8481V14.0676C12.1007 14.9416 12.1007 15.8156 12.0983 16.6896C12.0993 16.8089 12.0789 16.9273 12.0381 17.0383C11.9977 17.1346 11.9308 17.2153 11.8463 17.2694C11.7619 17.3235 11.664 17.3484 11.5659 17.3409C11.4618 17.3272 11.3644 17.2784 11.2879 17.2014C11.2114 17.1245 11.1596 17.0234 11.1401 16.9128C11.1267 16.8232 11.1212 16.7325 11.124 16.6418C11.124 15.7888 11.124 14.9358 11.124 14.0828V13.8412L10.9307 13.8318C10.9221 13.8881 10.9164 13.9449 10.9136 14.002C10.9136 14.8949 10.9165 15.7914 10.9087 16.6864C10.9091 16.831 10.8777 16.9737 10.8172 17.1029C10.7237 17.2883 10.5534 17.3682 10.3528 17.3335C10.2558 17.3153 10.1664 17.2658 10.0965 17.1915C10.0265 17.1173 9.97933 17.0219 9.96127 16.9181C9.94773 16.8214 9.942 16.7237 9.94414 16.626C9.94414 15.7797 9.94414 14.9337 9.94414 14.0881V13.8297C9.84138 13.8297 9.75329 13.8334 9.66521 13.8297C9.45577 13.8192 9.3897 13.7246 9.43326 13.5051C9.6352 12.4879 9.83763 11.4707 10.0405 10.4535C10.0469 10.4209 10.0518 10.3878 10.0626 10.3217C9.86291 10.3742 9.67793 10.4094 9.50421 10.4766C9.07945 10.6405 8.65909 10.6667 8.22797 10.5071C8.19386 10.4999 8.15867 10.5014 8.12519 10.5114C8.09172 10.5215 8.06089 10.5398 8.03516 10.5648C7.68723 10.9745 7.16411 10.8873 6.96739 10.3695C6.77067 9.85158 6.58716 9.33002 6.40218 8.80847C6.16142 8.12987 5.92555 7.44969 5.68674 6.77109C5.66397 6.69634 5.62448 6.62872 5.57174 6.57413C5.65689 7.05944 5.73959 7.54476 5.82719 8.02955C6.0151 9.07108 6.20644 10.1126 6.39386 11.1542C6.47314 11.5948 6.35031 11.7519 5.93289 11.754H5.61774V12.0166C5.61774 13.4846 5.61774 14.9532 5.61481 16.4212C5.61734 16.5673 5.59699 16.7129 5.55462 16.8519C5.49957 17.0028 5.40185 17.1314 5.2752 17.2197C5.14855 17.308 4.99933 17.3514 4.84848 17.344C4.69439 17.335 4.5468 17.2744 4.4264 17.1708C4.306 17.0672 4.21882 16.9257 4.17708 16.7663C4.14907 16.6445 4.13591 16.5193 4.13793 16.3939C4.13565 14.9397 4.13565 13.4853 4.13793 12.0308V11.7681H3.81985V12.0245C3.81985 13.5067 3.81985 14.9889 3.81985 16.4711C3.81985 16.8965 3.62411 17.2027 3.2933 17.3078C2.82009 17.458 2.36352 17.0888 2.34248 16.5283C2.33074 16.2132 2.33955 15.898 2.33906 15.5829V11.7534C2.19225 11.7534 2.07089 11.7571 1.94757 11.7534C1.62557 11.7419 1.49492 11.5827 1.55266 11.2398C1.66962 10.5459 1.79734 9.85473 1.9231 9.16195C2.07578 8.31317 2.22895 7.4644 2.34395 6.60302C2.31508 6.68338 2.28523 6.76059 2.25831 6.84305C1.90696 7.88651 1.55592 8.93032 1.20522 9.97448C1.07652 10.3542 0.782903 10.5381 0.464822 10.4498C0.0806768 10.3448 -0.0940235 9.9624 0.0503367 9.52541C0.31361 8.72968 0.583735 7.93658 0.849945 7.1419C1.08728 6.43232 1.3119 5.718 1.56587 5.01524C1.75721 4.48423 2.05866 4.04671 2.6219 3.91225C2.72096 3.88935 2.82202 3.87791 2.92335 3.87811C3.62998 3.87496 4.3371 3.87233 5.04373 3.87811C5.76259 3.88389 6.15457 4.36343 6.3924 5.01471C6.7599 6.02158 7.10001 7.04053 7.4543 8.05318C7.60943 8.497 7.77434 8.93767 7.92702 9.38307C7.96812 9.50282 8.02734 9.57583 8.14772 9.58739C8.15241 9.58763 8.15704 9.58869 8.16142 9.59054C8.71831 9.8563 9.2566 9.67037 9.79098 9.50335C10.4761 9.28905 11.1744 9.36574 11.8673 9.3899C12.1864 9.40145 12.3948 9.64936 12.5289 9.94507C12.6361 10.1814 12.7168 10.4314 12.8123 10.683C13.078 10.5044 13.2527 10.3112 13.2874 9.93719C13.4342 8.34574 13.6168 6.75743 13.7954 5.16913C13.8776 4.43381 14.4878 3.86393 15.2253 3.85343C16.3453 3.83662 17.4654 3.83662 18.5857 3.85343C19.2933 3.86341 19.8321 4.37866 19.9681 5.11713C20.0102 5.14707 19.9897 5.16546 20.0009 5.18962L19.9999 10.432Z" fill="#001F2A"/>
                    <path d="M3.98769 3.43027C3.81979 3.43117 3.65337 3.39655 3.49794 3.3284C3.34251 3.26026 3.20111 3.15991 3.08182 3.03309C2.96253 2.90628 2.86769 2.75548 2.80271 2.58931C2.73773 2.42315 2.70389 2.24487 2.70312 2.06466C2.70967 1.70608 2.84698 1.36456 3.08556 1.11345C3.32415 0.862341 3.64497 0.72168 3.97912 0.72168C4.31327 0.72168 4.6341 0.862341 4.87268 1.11345C5.11127 1.36456 5.24858 1.70608 5.25512 2.06466C5.25308 2.42526 5.11905 2.77055 4.88194 3.02602C4.64482 3.2815 4.32364 3.42669 3.98769 3.43027Z" fill="#001F2A"/>
                    <path d="M10.1447 8.02063C10.1463 7.77035 10.2404 7.53099 10.4063 7.35504C10.5721 7.1791 10.7962 7.08092 11.0294 7.08204C11.2594 7.08836 11.4782 7.18973 11.6402 7.36499C11.8022 7.54025 11.8949 7.77588 11.899 8.02273C11.899 8.27347 11.8062 8.51394 11.641 8.69124C11.4758 8.86854 11.2518 8.96815 11.0182 8.96815C10.9024 8.96901 10.7877 8.94501 10.6808 8.89757C10.5738 8.85014 10.4768 8.78021 10.3954 8.69192C10.314 8.60363 10.2499 8.49876 10.2068 8.38347C10.1638 8.26819 10.1426 8.14482 10.1447 8.02063V8.02063Z" fill="#001F2A"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_52310_2301">
                    <rect width="20" height="16.6667" fill="white" transform="translate(0 0.666992)"/>
                    </clipPath>
                    </defs>
                </svg>
                <span>Sauvegarder</span>
              </div>
            </div>
            {/*  */}

            <div className="infoBtn btnQuoteAsk" onClick={this.showQuoteAskForm} style={{ "--f-main-color": mainColor, "--f-font-color": fontColor }}>
              <div className='svgContainer'>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 13.4167C9.00936 13.4176 8.03756 13.1459 7.19095 12.6315C6.34435 12.1171 5.65557 11.3797 5.2 10.5H10V8.83334H4.65C4.60833 8.55834 4.58333 8.28334 4.58333 8C4.58333 7.71667 4.60833 7.44167 4.65 7.16667H10V5.5H5.2C5.65638 4.62099 6.34534 3.88415 7.19177 3.36983C8.03819 2.85551 9.00957 2.58346 10 2.58334C11.3417 2.58334 12.575 3.075 13.525 3.89167L15 2.41667C13.6278 1.18123 11.8464 0.498336 10 0.500003C6.73333 0.500003 3.96667 2.59167 2.93333 5.5H0V7.16667H2.55C2.48251 7.72018 2.48251 8.27983 2.55 8.83334H0V10.5H2.93333C3.96667 13.4083 6.73333 15.5 10 15.5C11.925 15.5 13.675 14.775 15 13.5833L13.5167 12.1083C12.575 12.925 11.35 13.4167 10 13.4167Z" fill={fontColor}/>
                </svg>
                <span>Demander un devis</span>
              </div>
            </div>
          </div>
        </MediaQuery>
        
        <Modal
          isOpen={familyService.loginModal}
          onRequestClose={() => this.props.familySpaceAction.closeLoginModal()}
          className='familyspace-login-modal'
          overlayClassName='familyspace-login-overlay'
        >
        {configurator.configuration &&
          <SFamilyLoginForm
            url={`/famille/${configurator.configuration.client}/familyspace`}
            close={() => this.props.familySpaceAction.closeLoginModal()}
          />
        }
        </Modal>
        <Modal
          isOpen={confirmBackToCatalog}
          onRequestClose={()=>this.backToCatalogModal(false)}
          className='backToCatalogModal'
          >
            <h1>Revenir au Catalogue</h1>
            <p>En revenant au catalogue votre configuration sera perdue</p>
            <button className='bcmContinue' onClick={()=>this.goToCatalog()}>Continuer</button>
            <button className='bcmCancel' onClick={()=> this.backToCatalogModal(false)}>Annuler</button>
          </Modal>
        <Modal
          isOpen={!!(configurator && shareModalVisible)}
          onRequestClose={() => this.setState({ shareModalVisible: false })}
          className='customize-share-modal'
          overlayClassName='customize-share-modal-overlay'
        >
          <SocialNetwork
            callback={this.displayAlertSentMail}
            getSocialStats={(item) => this.updateConfigSocialStats(item)}
            closeFromModal={() => this.setState({ shareModalVisible: false })}
            newDesign
          />
        </Modal>

        <Modal
          isOpen={show3DView}
          onRequestClose={() => this.setState({ show3DView: false })}
          className='customize-viewer3d-modal'
          overlayClassName='customize-viewer3d-modal-overlay'
        >
          {configurator && (
            <Viewer3D configuration={configurator.configuration} />
          )}
        </Modal>

        <Modal
          isOpen={showPdfModal && !!pdfUrl}
          onRequestClose={() =>{
              window.history.back();
            }
          }
          className='Pdf'
        >
          <iframe
            className='thePdf'
            src={pdfUrl}
            width='100%'
            title='documents'
            height='100%'
            style={{ border: 0, margin: 0, padding: 0 }}
          />
        </Modal>

        <Modal
          isOpen={showConfirmModal}
          onRequestClose={() => this.setState({ showConfirmModal: false })}
          hideClose
          className='customize-modal'
          overlayClassName='customize-modal-overlay'
        >
          <div className='modal-content'>
            <div className='modal-body'>Retourner au catalogue</div>

            <div className='modal-button actions'>
              <Button
                onClick={() => this.setState({ showConfirmModal: false })}
              >
                Annuler
              </Button>
              <Button onClick={() => this.goEndpoint('fcatalog', true)}>
                Confirmer
              </Button>
            </div>
          </div>
        </Modal>
        
        <Modal isOpen={loadPdf && !this.state.pdfData} className="pdfLoadingModal">
          {this.props.configurator.configuration.configType=='family' && <><FLoader size="S"/>
          <p>Chargement en cours...</p></>}
        </Modal>
        {showAlert === 1 && (
          <Alert color='success'>Votre mail a bien été envoyé</Alert>
        )}
        {showAlert === 2 && (
          <Alert color='danger'>Erreur sur envoi de mail</Alert>
        )}
      </div>
    )
  }
}

export const Fcustomize = connect(
  (state) => ({
    config: state.adminConfig.config,
    configurator: state.configurator.current,
    loading: state.configurator.loading,
    isoview: state.isoView,
    user: state.user,
    familyService: state.familyService,
    familySpace: state.familyService.familySpace,
    familySpaceUser: state.familyService.user
    // familySpaceUser: state.familyService.user
  }),
  (dispatch) => ({
    uiActions: bindActionCreators(uiActions, dispatch),
    configurationActions: bindActionCreators(configurationActions, dispatch),
    adminConfigActions: bindActionCreators(adminConfigActions, dispatch),
    familySpaceAction: bindActionCreators(familySpaceActions, dispatch),
    updateConfigurationAction: bindActionCreators(
      updateConfigurationActions,
      dispatch
    )
  })
)(FcustomizeComponent)